import React, { useState, useEffect } from "react";
import Droppable from "./Droppable";
import Draggable from "./Draggable";
import { extractDomainName } from '../utils/URLUtils';
import { base64ToImage } from '../utils/VerbatimUtils';
import "./Slide.css";

const Slide = ({ slide, notes, onDeleteNote, onUpdateTitle }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [currentTitle, setCurrentTitle] = useState(slide.title);

  useEffect(() => {
    setCurrentTitle(slide.title); // Update title when slide prop changes
  }, [slide.title]);

  const handleTitleChange = (event) => {
    setCurrentTitle(event.target.value);
  };

  const handleTitleBlur = () => {
    setIsEditing(false);
    onUpdateTitle(slide.id, currentTitle);
  };

  return (
    <div className="slide">
      {isEditing ? (
        <input
          type="text"
          value={currentTitle}
          onChange={handleTitleChange}
          onBlur={handleTitleBlur}
          className="title-input"
          autoFocus
        />
      ) : (
        <div className="title-display" onClick={() => setIsEditing(true)}>
          {currentTitle || "Click to edit title..."}
        </div>
      )}
      <Droppable id={`droppable-${slide.id}`}>
        {notes.map((note) => (
          <Draggable
            key={note.id}
            id={note.id}
            content={
              <>
                {typeof note.content === 'string' && <>
                  {note.content}
                  {note.link && (
                    <a href={note.link} target="_blank" rel="noopener noreferrer">
                      ({extractDomainName(note.link)}) {/* Use extractDomainName to shorten the link */}
                    </a>
                  )}
                </>}
                {Array.isArray(note.content) && 
                  <>
                    {note.content.map((item, index) => {
                      if (item.type === 'text' && item.content.trim() !== '') {
                        return (
                          <>
                            {item.content}
                            {note.link && (
                              <a href={note.link} target="_blank" rel="noopener noreferrer">
                                ({extractDomainName(note.link)}) {/* Use extractDomainName to shorten the link */}
                              </a>
                            )}
                          </>
                        );
                      } else if (item.type === 'image' && item.content) {
                        return (
                          <div key={index} className="review-image-block">
                            <img 
                              src={base64ToImage(item.content)} 
                              alt="Verbatim" 
                              className="review-verbatim-image"
                              onError={(e) => {
                                console.error("Erreur de chargement de l'image", e);
                                e.target.src = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2YwZjBmMCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMjAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IiM5OTkiPkltYWdlIEVycm9yPC90ZXh0Pjwvc3ZnPg==";
                              }}
                            />
                          </div>
                        );
                      }
                      return null;
                    })}
                  </>
                }
              </>
              // <>{renderNoteContent(note)}</>
            }
            styles={{
              position: "absolute",
              left: `${note.position.x}px`,
              top: `${note.position.y}px`,
            }}
            onDelete={onDeleteNote}
          />
        ))}
      </Droppable>

    </div>
  );
};

export default Slide;
